import styled, { css } from "styled-components";
import { theme } from "@Styled";

export interface IStyledChoiceGrid {
    centeredChild: boolean;
    isDisabled: boolean;
}

export interface IStyledChoiceText {
    textPadding: boolean;
}

export interface IStyledChoiceWrapper {
    isUserChoice: boolean;
    hoverEffect: boolean;
}

export const StyledChoiceImageWrapper = styled.div``;

export const StyledChoiceImage = styled.img`
    width: 100%;
`;

const userChoiceBorder = {
    "border-color": theme.palette.common.tbCyan,
};
const defaultChoiceBorder = {
    "border-color": theme.palette.common.lightGray,
};

export const StyledChoiceWrapper = styled.div<IStyledChoiceWrapper>(
    ({ theme, isUserChoice, hoverEffect }) => {
        return css`
            width: inherit;
            margin-bottom: 1em;
            position: relative;
            border: 1px solid;
            border-radius: 12px;
            ${isUserChoice ? userChoiceBorder : defaultChoiceBorder};

            :hover {
                border-color: ${hoverEffect && theme.palette.common.tbCyan};
                & p {
                    color: ${hoverEffect && theme.palette.common.tbCyan};
                }
            }
        `;
    }
);

export const StyledChoiceGrid = styled.div<IStyledChoiceGrid>(
    ({ centeredChild, isDisabled }) => {
        return css`
            display: flex;
            justify-content: ${centeredChild ? "center" : "space-between"};
            align-items: center;
            position: relative;
            width: 100%;
            height: 2rem;
            border-radius: inherit;
            cursor: ${isDisabled ? "not-allowed" : "pointer"};
            overflow: hidden;

            @media (max-width: 767px) {
                height: auto;
                min-height: 2.75rem;
            }
        `;
    }
);

export const StyledChoiceText = styled.p<IStyledChoiceText>(
    ({ theme, textPadding }) => {
        return css`
            color: ${theme.palette.common.tbBlue};
            transition: 0.8s;
            z-index: 2;
            font-size: 0.9rem;
            font-weight: 500;
            line-height: 1.35;
            text-align: left;
            white-space: normal;
            word-break: break-word;
            flex: 1 1 auto;
            min-width: 0;
            z-index: 2;
            margin-left: 12px;
            ${textPadding && { ...{ "margin-left": "12px" } }};

            @media (max-width: 767px) {
                font-size: 0.85rem;
            }
        `;
    }
);

export const StyledChoiceValue = styled.span(({ theme }) => {
    return css`
        color: ${theme.palette.common.tbBlue};
        display: flex;
        align-items: center;
        align-self: center;
        justify-content: center;
        transition: 0.8s;
        z-index: 2;
        font-size: 0.9rem;
        font-weight: 500;
        line-height: 20px;
        margin-right: 12px;
    `;
});
